import { render, staticRenderFns } from "./SaleModuleExplain.vue?vue&type=template&id=f8f22b26&scoped=true"
import script from "./SaleModuleExplain.vue?vue&type=script&lang=js"
export * from "./SaleModuleExplain.vue?vue&type=script&lang=js"
import style0 from "./SaleModuleExplain.vue?vue&type=style&index=0&id=f8f22b26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f22b26",
  null
  
)

export default component.exports